const releaseNotes = [
  {
    version: '1.6.22',
    changes: [
      {
        ticket: 'SD #4957',
        title: 'Antritte kommen nicht im System an.',
        tenant: 'thurbo',
        text: `Die Antritte kommen nun wieder wie erwartet im System an oder es wird eine entsprechende Meldung angezeigt.`,
      },
    ],
  },
  {
    version: '1.6.21',
    changes: [
      {
        title: 'Diverse Optimierungen',
        text: `Diverse Optimierungen und Behebung von Fehlern.`,
      },
    ],
  },
  {
    version: '1.6.20',
    changes: [
      {
        ticket: 'OP-8141',
        title: 'Nicht abgeschickte Formulare zwischenspeichern',
        text: `Solange ein Formular nicht abgeschickt worden ist, werden die Eingaben zwischengespeichert - auch über einen Neustart der App hinaus`,
      },
    ],
  },
  {
    version: '1.6.19',
    changes: [
      {
        ticket: 'SD #4758',
        title: 'Eingereichtes Formular wird nicht in Cockpit gesendet',
        tenant: 'zvb',
        text: `Die eingereichten Formulare werden wieder korrekt übertragen`,
      },
    ],
  },
  {
    version: '1.6.18',
    changes: [
      {
        ticket: 'SD #4757',
        title: 'Fahrzeugskizze im Unfalldesk nicht angezeigt',
        tenant: 'lvb',
        text: `Die Fahrzeugskizzen im Unfalldesk werden wieder angezeigt`,
      },
      {
        ticket: 'SD #4749',
        title: 'Chat Meldungen mehrfach',
        tenant: 'lvb',
        text: `Aufgrund der zum Push Services gesperrten Verbindung und eines nicht idealen Verhaltens in diesem Fall, wurden Chat Meeldungen mehrfach gespeichert und angezeigt. Dieser Release enthält die mit dem Bugfix von 19.08.24 ausgelieferten und in den Release integrierten Änderungen`,
      },
    ],
  },
  {
    version: '1.6.17',
    changes: [
      {
        ticket: 'SD #4720',
        title: 'WebApp 1.6.15 / 21.19.8 - Dokumente nicht alphabetisch sortiert in WebApp',
        tenant: 'thurbo',
        text: `Die Sortierung der Dokumente erfolgt nun gemäss Definition im Cockpit`,
      },
      {
        ticket: 'SD #4556',
        title: 'Löschen für alle im Chat soll immer verfügbar sein',
        text: `Die Funktionalität zum Löschen einer Nachricht steht nun ohne Einschränkung zur Verfügung`,
      },
    ],
  },
  {
    version: '1.6.16',
    changes: [
      {
        ticket: 'ZenDesk #4690',
        title: 'Geschwärztes Unterschriftsfeld',
        text: `Das Unterschriftenfeld wurde in manchen Situationen geschwärzt dargestellt. Dies v.a. auch im PDF. Dieses Verhalten wurde hiermit gelöst. Gleichzeitig fanden einige Verbesserungen bezüglich der Farbgebung im Formularmodul statt`,
      },
      {
        ticket: 'ZenDesk #4796',
        title: 'Fehler beim Öffnen von einzelnen Mappe im Dateimodule Webapp öV Pad',
        tenant: 'ZVB',
        text: `Ein Fehler bei der Filterfunktion im Dokumentenmodul verhinderte die normale Navigation in der Ordnerhierarchie. Dieser Fehler wurde mit diesem Release korrigiert.`,
      },
      {
        ticket: 'ZenDesk #4670',
        title: 'MAG Gesamtdurchschnitt falsch',
        tenant: 'ZVB',
        text: `Korrektur der Gesamtdurchschnittsberechnung`,
      },
    ],
  },
  {
    version: '1.6.15',
    changes: [
      {
        ticket: 'ZenDesk #4723, JIRA OP-8278',
        tenant: 'thurbo',
        title: 'Anzeige Meldungen bei der Antrittskontrolle',
        text: `Die Antrittskontroll-Meldungen/Verständigungen werden bei der Antrittskontrolle zwecks Bestätigung angezeigt`,
      },
    ],
  },
  {
    version: '1.6.14',
    changes: [
      {
        ticket: 'ZenDesk 4672 / JIRA OP-8124',
        title: 'Neue Optionen zum Ignorieren von Fahrdienst Dokumenten in Widgets',
        text: `In Widgets, welche nur ungelesene oder nur zu quittierende anzeigen, gibt es nun je eine Option (von InnoTix zu pflegen), welche Fahrdienst Dokumente ausblendet: ignoreFahrdienstFilesInUnreadOnly=true, ignoreFahrdienstFilesInToAcknowledgeOnly=true`,
      },
    ],
  },
  {
    version: '1.6.13',
    changes: [
      {
        ticket: '',
        tenant: 'vbz',
        title: 'Verbesserte Dienstaggregation',
        text: `Die Dienstaggregation aggregiert Umlaufstücke nur noch bei identischer Linie/Kurs Information`,
      },
    ],
  },
  {
    version: '1.6.12',
    changes: [
      {
        ticket: 'ZenDesk-5672 / OP-8124',
        tenant: 'zvb',
        title: 'Widget Tourenblätter entfernt',
        text: `Das Widget mit den Tourenblätter-Dokumenten wurde entfernt, weil die Filterung ohne den Kontext von Dienst/Linien/Tage zu wenige Vorteile gegenüber dem eigentlichen Modul bringt.`,
      },
      {
        ticket: 'ZenDesk-5672 / OP-8124',
        title: 'Anzeige von, bis in Widgets auch bei Fahrdienst Modulen berücksichtigt',
        text: `Das Anzeige von, bis Datum wurde bisher in Widgets, welche die Dokumente aus Fahrdienst/Fahrdienst452 Modulen zusammengezogen hatten, nicht berücksichtigt. Wir haben diese Filterung nun ergänzt`,
      },
    ],
  },
  {
    version: '1.6.11',
    changes: [
      {
        ticket: 'ZenDesk-4614 / OP-8045',
        tenant: 'zvb',
        title: 'Anzeige bisheriger Begleitfahrten WebApp',
        text: `Ticket gelöst`,
      },
      {
        ticket: 'ZenDesk-4525',
        tenant: 'zvb',
        title: 'MAG: einbezogene Begleitfahrten werden nicht dargestellt',
        text: `Gelöstes Ticket (OP-7907)`,
      },
      {
        ticket: 'OP-7999',
        tenant: 'zvb',
        title: 'Finale Konfiguration "Bottom Navigation" und Widgets',
        text: `Die Bottom Navigation wurde zusammen mit den konfigurierten Widgets und Direktlinks auf Module, final überarbeitet.`,
      },
    ],
  },
  {
    version: '1.6.10',
    changes: [
      {
        ticket: 'OP-8051',
        tenant: 'lvb',
        title: 'Texte für alle Dokumente lesen',
        text: `Die fehlenden Textressourcen wurden hinzugefügt`,
      },
      {
        ticket: 'OP-8055',
        title: 'Kamera/Galerie Selektion bei Foto-Upload Feldern',
        text: `Bei Foto-Upload Feldern wurde die Wahl zwischen Kamera und Gallerie wiederum aktiviert.`,
      },
    ],
  },
  {
    version: '1.6.9',
    changes: [
      {
        ticket: 'OP-7694',
        tenant: 'zvb',
        title: 'Widget Konfigurations Verbesserungen',
        text: `Die Konfiguration der Widgets, welche über die Bottom Navigation erreichbar sind, wurde "generalüberholt"`,
      },
      {
        ticket: 'OP-7907',
        tenant: 'zvb',
        title: 'MAG Gesamtbewertung Begleitfahrten',
        text: `Die Anzeige der gesamten Bewertung der Begleitfahrten erfolgt nun unmittelbar - auch wenn der Benutzer offline ist`,
      },
    ],
  },
  {
    version: '1.6.8',
    changes: [
      {
        ticket: 'ZenDesk-4513',
        title: 'Formularliste verbessert',
        text: `Speicherung des Lesezustands nach dem erstmaligen Öffnen eines Formulars. Zusätzlich werden im Formularmodul neu nur noch farbige Kreise zur Markierung von neuen oder geänderten Formularen angezeigt. Eine textuelle Markierung wird nicht mehr angezeigt, da diese bei den Formularen keinen Mehrwert bieten`,
      },
      {
        ticket: 'ZenDesk-4392',
        title: 'Falsche Uhrzeit im Messaging Modul',
        text: `Der Zeitstempel bei Nachrichten, welche aus der WebApp gesendet wurden, wich ab von aus dem Cockpit gesendet Nachrichten. Dieses fehlerhafte Verhalten wurde hiermit korrigiert.`,
      },
      {
        ticket: 'ZenDesk-4386',
        tenant: 'rhb',
        title: 'Korrektur bei gelesen / zu quittieren Widgets',
        text: `Die Filterung der Dokumente aufgrund der Widget-Einstellungen (gelesen, aber nicht quittiert und zu quittieren) wurde korrigiert`,
      },
    ],
  },
  {
    version: '1.6.7',
    changes: [
      {
        title: 'Verbesserung im Bereich Widget-Konfiguration',
        text: `Die Widgets, welche aus der Bottom Navigation aufgerufen werden, können nun noch besser durch den Hersteller oder aber den Benutzer konfiguriert werden. Die Filterung nach ungelesenen und zu quittierenden Dokumenten kann jetzt getrennt erfolgen.`,
      },
    ],
  },
  {
    version: '1.6.6',
    changes: [
      {
        title: 'Worksheet Fertigstellung',
        text: `Das VBZ Worksheet wurde fertiggestellt (CR 2024-04-15)`,
        tenant: 'vbz',
      },
      {
        title: 'Kundenmodul',
        text: `Ein kundenspezifisches Modul wurde mit dem Release 1.6.6 geliefert.`,
      },
    ],
  },
  {
    version: '1.6.5',
    changes: [
      {
        ticket: 'ZenDesk-4389',
        title: 'Anzeige von/bis im Fahrdienst Modul korrigiert',
        text: `Die Anzeige-Beschränkung im Fahrdienst Modul war beim Enddatum auf exklusiv eingestellt. D.h. am Enddatum wurde das Dokument nicht mehr angezeigt. Das Verhalten ist jetzt so korrigiert, dass die Anzeige auch am Enddatum selbst erfolgt.`,
      },
    ],
  },
  {
    version: '1.6.4',
    changes: [
      {
        ticket: 'ZenDesk-4315',
        title: 'Kamera-Zugriff',
        text: `Auf gewissen Tablets wurde festgestellt, dass der direkte Kamera-Zugriff aus Formularen oder Unfalldesk nicht mehr funktionierte. Dies wurde mit diesem Release korrigiert.`,
      },
    ],
  },
  {
    version: '1.6.3',
    changes: [
      {
        tenant: 'bogg',
        ticket: 'Kundenauftrag',
        title: 'Prozesslandkarte',
        text: `Es wurde ein neues Dokumentenmodul mit überlagerter Navigation entlang der defninierten Prozesse programmiert (Prozesslandkarte)`,
      },
    ],
  },
  {
    version: '1.6.2',
    changes: [
      {
        ticket: 'ZenDesk-4301',
        title: 'Fahrdienst452 und Mein Dienst von-bis Filter korrigiert',
        text: `Korrektur der Anzeige von-bis Daten auf den Fahrdienst Dokumenten `,
      },
      { ticket: 'ohne Ticket', title: 'Formular Modul Publikationsdatum', text: `Formular Modul ohne Anzeige des ungültigen Publikationsdatum` },
    ],
  },
  {
    version: '1.6.1',
    changes: [
      {
        ticket: 'ZenDesk-4301',
        title: 'Fahrdienst452 und Mein Dienst Dokumentenfilter korrigiert',
        text: `Mit V1.6.0 wurde ein Bug bei der Filterung der relevanten Dokumente eingeführt. Dies wurde mit V1.6.1 korrigiert`,
      },
      {
        ticket: 'ZenDesk-4295',
        title: 'Fahrdienst452 Zähler Bubble nicht aktualisiert',
        text: `Der Zähler aktualisiert unmittelbar nachdem ein Dokument als Gelesen markiert wurde`,
      },
    ],
  },
  {
    version: '1.6.0',
    changes: [
      {
        title: 'SendBox',
        text: `Das Verhalten der SendBox beim Wechsel zwischen Online- und Offline-Modus wurde optimiert.`,
      },
      {
        title: 'Fehler-Korrekturen',
        text: `Diverse kleinere Fehler und Unschönheiten wurden korrigiert.`,
      },
    ],
  },
  {
    version: '1.5.9',
    changes: [
      {
        title: 'Bild mit Verweisen auf Dokumente',
        text: `Auf der Startseite eines Dokumentenmoduls kann neu ein Bild angezeigt werden, auf dem definierte Bereiche mit Dokumenten aus dem Modul verlinkt werden können. Das Bild und dessen klickbare Bereiche müssen von InnoTix hochgeladen und definiert werden.`,
      },
    ],
  },
  {
    version: '1.5.8',
    changes: [
      {
        title: 'Mein Dienst Kalenderansicht mit Dienstvorschau',
        text: `Die Dienstansicht wurde ergänzt durch eine wochenbasierte Kalenderansicht mit einer Dienstvorschau`,
      },
      {
        title: 'Schriftgrössen-Skalierung',
        text: `Die automatische Skalierung der Schriftgrösse wurde optimiert.`,
      },
    ],
  },
  {
    version: '1.5.7',
    changes: [
      {
        title: 'CalDav Anbindung Mein Dienst',
        text: `Die Mein Dienst Daten können nun mit dem Kalender synchronisiert werden.`,
      },
    ],
  },
  {
    version: '1.5.6',
    changes: [
      {
        title: 'Azure AD Anmeldung verbessert',
        text: `Für Kunden, welche die Azure AD Anmeldung nutzen, wurde diese bei neuen Benutzern verbessert. Neu wird ein neuer Benutzer im Cockpit angelegt.`,
      },
      {
        title: 'MitarbeiterInnen-Modul mit Foto-Upload',
        text: `Ein eigenes Profil-Foto kann im Profil hochgeladen werden, wenn das MitarbeiterInnen-Modul aktiviert ist`,
      },
    ],
  },
  {
    version: '1.5.5',
    changes: [
      {
        tenant: 'demoapp',
        ticket: 'OP-55734',
        title: 'Telemetrie Modul Datumsbereich alle Daten',
        text: `Im Telemetrie Modul gibt es auf den Testsystemen eine neue Option "alle Daten". Dies wird auf der Beta und Prod aus Performance-Gründen unterbunden`,
      },
      {
        tenant: 'bogg',
        ticket: 'OP-5803',
        title: 'Neues Dokumentenmodul "Baustellen"',
        text: `Das neue Dokumentenmodul wurde eingeführt`,
      },
      {
        tenant: 'dsw21',
        ticket: 'ZenDesk-3318',
        title: 'Fahrdienst452 Verbesserungen',
        text: `Die Verbesserungswünsche im Bereich des Fahrdienst452 wurden berücksichtigt. Insbesondere die Auswahl der Kurse und Umläufe wurde stark customized. Die Linien werden jetzt als Kürzel angezeigt.`,
      },
    ],
  },
  {
    version: '1.5.4',
    changes: [
      {
        ticket: 'NEW',
        title: 'Media Modul',
        text: `Mit dem Media Modul können verschiedene Medientypen gemischt angezeigt werden.`,
      },
      {
        ticket: 'Kein Ticket',
        title: 'PDf Viewer Downgrade',
        text: `Der Pdf Viewer wurde aufgrund von Kompatibilitätsproblemen auf eine frühere Version zurückgesetzt.`,
      },
    ],
  },
  {
    version: '1.5.3',
    changes: [
      {
        ticket: 'NEW',
        title: 'Telemetrie Modul',
        text: `Das Telemetrie Modul ermöglicht die grafische Darstellung von verschiedenen Telemetrie Kennzahlen.`,
      },
      {
        ticket: 'OP-5290',
        title: 'Dokumentenmenu schliessen',
        text: `Klick auf Schliessen-Icon des Dokumentenmenu führt auf Home zurück, wenn kein Dokument angezeigt wird`,
      },
    ],
  },
  {
    version: '1.5.2',
    changes: [
      {
        ticket: 'OP-5290',
        title: 'Sortierung Dokumente initial setzen',
        text: `Die Sortierung der Dokumente kann vom Benutzer eingestellt werden. Neu gibt es die Möglichkeit, den Default bei einem Rollout der App neu zu setzen. Benutzerseitig kann die Sortierung aber nach wie vor verändert werden`,
      },
      {
        ticket: 'OP-5290',
        title: 'Dokumentenmenu schliessen',
        text: `Klick auf Schliessen-Icon des Dokumentenmenu führt auf Home zurück, wenn kein Dokument angezeigt wird`,
      },
    ],
  },
  {
    version: '1.5.1',
    changes: [
      {
        ticket: 'OP-4559',
        title: 'Fahrdienst Modul offline issue',
        text: `Ein Problem im offline Betrieb des Fahrdienst Modules wurde gelöst`,
      },
    ],
  },
  {
    version: '1.5.0',
    changes: [
      {
        ticket: 'verschiedene Tickets',
        title: 'Mitarbeitermodul',
        text: `Das MitarbeiterInnen Modul steht ab sofort in der WebApp zur Verfügung.`,
      },
      {
        ticket: 'ISSUE OP-5290',
        title: 'Pdf Darstellungsissues',
        text: `Auf leistungsschwächeren Samsung Smartphones gab es Darstellungsprobleme mit manchen PDF Dokumenten. Dies wurde durch den Upgrade der PDF Library zu 90% gelöst.`,
      },
    ],
  },

  {
    version: '1.4.48',
    changes: [
      {
        ticket: 'ISSUE OP-5121',
        title: 'Mehrfaches senden Wagenbuch Report verhindern',
        text: `Das mehrfache Absenden eines Wagenbuch Reports ist nicht mehr möglich`,
      },
    ],
  },
  {
    version: '1.4.47',
    changes: [
      {
        tenant: 'heag',
        ticket: 'ISSUE OP-5254',
        title: 'Icon Änderung usw.',
        text: `Änderung des App-Icons, Namens und diverser anderer kleiner Änderungen gemäss Ticket.`,
      },
    ],
  },
  {
    version: '1.4.46',
    changes: [
      {
        ticket: 'Verbesserung',
        title: 'Wagenbuch auf Smartphones',
        text: `Im Wagenbuch wird die Schadenliste auf Smartphones übersichtlicher dargestellt.`,
      },
      {
        ticket: 'Verbesserung',
        title: 'Fahrdienst Auswahl',
        text: `Im Fahrdienst Modul wird die Auswahl der Dienste/Datums direkt dargestellt`,
      },
    ],
  },
  {
    version: '1.4.45',
    changes: [
      {
        ticket: 'kein Ticket',
        title: 'Video Sortierung gemäss Cockpit',
        text: `Die Videos werden nun gemäss der Sortierreihenfolge im Cockpit sortiert.`,
      },
      {
        ticket: 'Kundenanfrage',
        title: 'Kopieren der Release Notes ins Clipboard',
        text: `Die Release Notes können ins Clipboard kopiert werden.`,
      },
    ],
  },
  {
    version: '1.4.44',
    changes: [
      {
        tenant: 'bogg',
        ticket: 'ZenDesk-3377',
        title: 'Zukünftige Fahrdienste werden nicht angezeigt',
        text: `Mit von-bis eingeschränkte Fahrdienste werden im Fahrdienst Pdf Modul wieder angezeigt.`,
      },
    ],
  },

  {
    version: '1.4.42',
    changes: [
      {
        ticket: 'OP-4574',
        title: 'Dokumente Vollscreen Modus',
        text: `Dokumente können durch einen Klick auf das quadratische Symbol unten rechts im Vollscreen Modus geöffnet werden. Der Vollscreen Modus wird auf gleiche Art und Weise verlassen.`,
      },
    ],
  },
  {
    version: '1.4.41',
    changes: [
      {
        ticket: 'kein Ticket',
        title: 'AppId Anzeige',
        text: `Die AppId wird nun im Cockpit angezeigt. In der WebApp ist sie im Navigation Drawer im Footer unten rechts versteckt sichtbar.`,
      },
    ],
  },
  {
    version: '1.4.40',
    changes: [
      {
        tenant: 'bogg',
        ticket: 'kein Ticket',
        title: 'Permanente Seitenliste ab 1100 Pixel Breite',
        text: `Die Seitenleiste wird nun bereits ab 1100 Pixel Breite permanent angezeigt.`,
      },
      {
        ticket: 'OP-3714',
        title: 'Bug beim Absenden von Unfalldesk Meldungen',
        text: `Teilweise wurden mehrere Reports erzeugt, was auf einen Bug zurückzuführen war. Dieser wurde behoben. Die Kringel in den Fahrzeugskizzen sollten jetzt in jedem Fall korrekt angezeigt werden.`,
      },
      {
        ticket: 'OP-3714',
        title: 'Unfalldesk Wagenskizzen-Kringel Positionierung',
        text: `Die Kringel in den Fahrzeugskizzen sollten jetzt in jedem Fall korrekt positioniert in den Reports erscheinen.`,
      },
      {
        tenant: 'lvb',
        ticket: 'Kein Ticket',
        title: 'Ereignisdatum ohne automatisch ausfüllen',
        text: `Das Ereignisdatum wird nicht mehr automatisch ausgefüllt.`,
      },
      {
        ticket: 'Kein Ticket',
        title: 'Warnung bei Nutzung Samsung Browser',
        text: `Der Samsung Browser verursacht Darstellungsprobleme und sollte darum nicht verwendet werden. Bei Verwendung eines solchen Browsers wird nun eine Warnung angezeigt.`,
      },
    ],
  },
  {
    version: '1.4.39',
    changes: [
      {
        ticket: 'ISSUE OP-4575',
        title: 'Verbesserte Darstellung der Galerie (Übersichtstext)',
        text: `Verbesserte Darstellung der Galerie in allen Ansichten auf allen Gerätegrössen und insbesondere der Übersichtstext wird nun nicht mehr abgeschnitten.`,
      },
      {
        ticket: 'kein Ticket',
        title: 'Warnung bei Nutzung Samsung Browser',
        text: `Der Samsung Browser verursacht Darstellungsprobleme und sollte darum nicht verwendet werden. Bei Verwendung eines solchen Browsers wird nun eine Warnung angezeigt.`,
      },
    ],
  },
  {
    version: '1.4.37',
    changes: [
      {
        ticket: 'ZenDesk-3238',
        title: 'Verbesserung Auswertung e-Learning ',
        text: `Behebung dieses Problems: Wird eine Frage mit mehreren richtigen Antwortmöglichkeiten nur teilweise richtig beantwortet, wird in der Auswertung auf dem Tablet die Frage auch als falsch beantwortet bewertet (richtig). In der Auswertung im Cockpit wird diese Frage allerdings mit richtig bewertet (falsch)`,
      },
    ],
  },
  {
    version: '1.4.36',
    changes: [
      {
        tenant: 'lvb',
        title: 'Kundenspezifische Anpassung',
        text: 'Fahrdienst452 / Mein Dienst Implementierung',
      },
    ],
  },
  {
    version: '1.4.35',
    changes: [
      {
        ticket: 'ISSUE',
        title: 'Cockpit Log Files mit korrigierten Zeitstempeln',
        text: 'Die Cockpit Logs im Device Reiter erhalten nun den richtigen Zeitstempel.',
      },
    ],
  },
  {
    version: '1.4.34',
    changes: [
      {
        ticket: 'FEATURE OP-4329',
        title: 'Anzeige Release Notes',
        text: 'Die Release Notes können ab Version 1.4.34 im Seitenmenu rechts durch Klick auf die Versionsnummer angezeigt werden.',
      },
    ],
  },
  {
    version: '1.4.33',
    changes: [
      {
        ticket: 'ISSUE OP-3771',
        title: 'Begrüssungsfenster der Vorschau im Cockpit angeglichen',
        text: 'Das Begrüssungsfenster wurde der Vorschau, welche im Cockpit verfügbar ist, angeglichen.',
      },
    ],
  },
];
export default releaseNotes;
